// Create Sendbird Group
export const CREATE_SENDBIRD_GROUP_REQUEST = 'CREATE_SENDBIRD_GROUP_REQUEST';
export const CREATE_SENDBIRD_GROUP_DONE = 'CREATE_SENDBIRD_GROUP_DONE';
export const CREATE_SENDBIRD_GROUP_FAILED = 'CREATE_SENDBIRD_GROUP_FAILED';
export const CREATE_SENDBIRD_GROUP_RESET = 'CREATE_SENDBIRD_GROUP_RESET';